export default "__VITE_ASSET__B08AAUFq__"